import * as React from 'react';
import getComponentClasses from '../../utils/app/getComponentClasses';

export type AvatarSize = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large';

export type Props = {
    user?: User;
    variations?: string[];
    isLinked?: boolean;
    isOnline?: boolean;
};

interface User {
    profileUrl: string;
    avatarUrl: string;
}

export class Avatar extends React.Component<Props, {}> {
    public static defaultProps: Partial<Props> = {
        variations: ['medium'],
        isLinked: true,
        isOnline: false,
    };

    placeholder() {
        return (
            <span className={getComponentClasses('avatar', this.props.variations)}>
                <span className="avatar__image avatar__image--placeholder" />
            </span>
        );
    }

    avatar(user: User) {
        const attrs = this.props.isOnline ? { 'data-online': true } : {};
        const { variations } = this.props;

        if (this.props.isLinked && user.profileUrl) {
            return (
                <a
                    className={getComponentClasses('avatar', variations)}
                    href={user.profileUrl}
                    {...attrs}
                >
                    <img
                        alt=""
                        role="presentation"
                        className="avatar__image"
                        src={user.avatarUrl}
                    />
                    {this.onlineIndicator()}
                </a>
            );
        } else {
            return (
                <span className={getComponentClasses('avatar', variations)} {...attrs}>
                    <img
                        alt=""
                        role="presentation"
                        className="avatar__image"
                        src={user.avatarUrl}
                    />
                    {this.onlineIndicator()}
                </span>
            );
        }
    }

    onlineIndicator() {
        return <div className="avatar__indicator" />;
    }

    render() {
        if (this.props.user) {
            return this.avatar(this.props.user);
        } else {
            return this.placeholder();
        }
    }
}
